import { Match, Show, Switch } from 'solid-js';
import { css } from '@emotion/css';
import { SuppliedPoster } from 'Shared/frontend/eventPosters/SuppliedPoster';
import { PhotoPoster } from 'Shared/frontend/eventPosters/PhotoPoster';
import { DateWrap, eventTaglineStyle, maxTextLines, nameStyle, Poster } from 'Shared/frontend/Poster';
import { MusicPoster } from 'Shared/frontend/eventPosters/MusicPoster';
import { poster } from 'Shared/frontend/SettingsProvider';


const imagelessNameStyle = () => css(nameStyle(), {
	width: '100%',
	minHeight: '1em',
	margin: '0.5em 0',
	padding: '0 3px',
	wordWrap: 'break-word',
	...maxTextLines(4)
});

const imagelessEventTaglineStyle = () => css(eventTaglineStyle(), {
	margin: '0 0.5em',
	...maxTextLines(4)
});


export function EventPoster(P)
{
	return (
		<Poster {...P}>
			<Switch>
				<Match when={P.eventType == 'music' && P.imageType == 'auto'}>
					<MusicPoster {...P} />
				</Match>
				<Match when={P.eventType != 'music' && P.imageType == 'auto'}>
					<ImagelessPoster {...P} />
				</Match>
				<Match when={P.imageType == 'photo'}>
					<PhotoPoster {...P} folder='Event-image' size='medium' />
				</Match>
				<Match when={P.imageType == 'poster'}>
					<SuppliedPoster {...P} folder='Event-image' size='medium' />
				</Match>
			</Switch>
		</Poster>
	);
}

function ImagelessPoster(P)
{
	const hide = () => P.posterSettings.hide ?? [];

	const s = () => P.posterSettings;
	const theme = () => poster(s().theme,'imagelessNamePoster');
	const nameSize = () => s().nameFontSize ?? theme().name.fontSize;
	const taglineSize = () => s().nameFontSize ?? theme().tagline.fontSize;

	return (
		<DateWrap {...P}>
			<Show when={!hide().includes('name') && P.name} fallback={<>&nbsp;</>}>
				<div class={css(imagelessNameStyle(), {fontSize: nameSize()} )}>
					{P.name}
				</div>
			</Show>
				
			<Show when={!hide().includes('tagline') && P.tagline}>
				<div class={css(imagelessEventTaglineStyle(), {fontSize: taglineSize()} )}>
					{P.tagline}
				</div>
			</Show>
		</DateWrap>
	);
}

